




























































import Vue from 'vue';
import Component from 'vue-class-component';
import Ribbon from '@/core/ribbon/ribbon.vue';
import JhiFooter from '@/core/jhi-footer/jhi-footer.vue';
import JhiNavbar from '@/core/jhi-navbar/jhi-navbar.vue';
import LoginForm from '@/account/login-form/login-form.vue';
import LoginService from '@/account/login.service';

import '@/shared/config/dayjs';
import { Inject } from 'vue-property-decorator';

@Component({
  components: {
    ribbon: Ribbon,
    'jhi-navbar': JhiNavbar,
    'login-form': LoginForm,
    'jhi-footer': JhiFooter,
  },
})
export default class App extends Vue {
  @Inject('loginService')
  private loginService: () => LoginService;

  public selectedItem: string = '';
  public menuItems: Array<{ label: string; link: string; icon: string; path1: string; path2?: string; path3?: string }> = [
    {
      label: 'Dashboard',
      link: 'Dashboard',
      icon: 'house-fill',
      path1:
        'm8 3.293 6 6V13.5a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 2 13.5V9.293l6-6zm5-.793V6l-2-2V2.5a.5.5 0 0 1 .5-.5h1a.5.5 0 0 1 .5.5z',
      path2: 'M7.293 1.5a1 1 0 0 1 1.414 0l6.647 6.646a.5.5 0 0 1-.708.708L8 2.207 1.354 8.854a.5.5 0 1 1-.708-.708L7.293 1.5z',
    },
    {
      label: 'Contratos',
      link: 'Formularios',
      icon: 'file-earmark-spreadsheet-fill',
      path1: 'M6 12v-2h3v2H6z',
      path2:
        'M9.293 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.707A1 1 0 0 0 13.707 4L10 .293A1 1 0 0 0 9.293 0zM9.5 3.5v-2l3 3h-2a1 1 0 0 1-1-1zM3 9h10v1h-3v2h3v1h-3v2H9v-2H6v2H5v-2H3v-1h2v-2H3V9z',
    },
    {
      label: 'Clientes',
      link: 'ClientesMenu',
      icon: 'people-fill',
      path1: 'M7 14s-1 0-1-1 1-4 5-4 5 3 5 4-1 1-1 1H7zm4-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6z',
      path2: 'M5.216 14A2.238 2.238 0 0 1 5 13c0-1.355.68-2.75 1.936-3.72A6.325 6.325 0 0 0 5 9c-4 0-5 3-5 4s1 1 1 1h4.216z',
      path3: 'M4.5 8a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5z',
    },
    {
      label: 'Portafolios',
      link: 'PortafoliosMenu',
      icon: 'bi bi-briefcase-fill',
      path1:
        'M6.5 1A1.5 1.5 0 0 0 5 2.5V3H1.5A1.5 1.5 0 0 0 0 4.5v1.384l7.614 2.03a1.5 1.5 0 0 0 .772 0L16 5.884V4.5A1.5 1.5 0 0 0 14.5 3H11v-.5A1.5 1.5 0 0 0 9.5 1zm0 1h3a.5.5 0 0 1 .5.5V3H6v-.5a.5.5 0 0 1 .5-.5',
      path2: 'M0 12.5A1.5 1.5 0 0 0 1.5 14h13a1.5 1.5 0 0 0 1.5-1.5V6.85L8.129 8.947a.5.5 0 0 1-.258 0L0 6.85z',
    },
    {
      label: 'Operaciones',
      link: 'Modulos?modulo=OPER',
      icon: 'currency-dollar',
      path1:
        'M4 10.781c.148 1.667 1.513 2.85 3.591 3.003V15h1.043v-1.216c2.27-.179 3.678-1.438 3.678-3.3 0-1.59-.947-2.51-2.956-3.028l-.722-.187V3.467c1.122.11 1.879.714 2.07 1.616h1.47c-.166-1.6-1.54-2.748-3.54-2.875V1H7.591v1.233c-1.939.23-3.27 1.472-3.27 3.156 0 1.454.966 2.483 2.661 2.917l.61.162v4.031c-1.149-.17-1.94-.8-2.131-1.718H4zm3.391-3.836c-1.043-.263-1.6-.825-1.6-1.616 0-.944.704-1.641 1.8-1.828v3.495l-.2-.05zm1.591 1.872c1.287.323 1.852.859 1.852 1.769 0 1.097-.826 1.828-2.2 1.939V8.73l.348.086z',
    },

    {
      label: 'Consultas',
      link: 'Reportes',
      icon: 'graph-up',
      path1:
        'M0 0h1v15h15v1H0V0Zm14.817 3.113a.5.5 0 0 1 .07.704l-4.5 5.5a.5.5 0 0 1-.74.037L7.06 6.767l-3.656 5.027a.5.5 0 0 1-.808-.588l4-5.5a.5.5 0 0 1 .758-.06l2.609 2.61 4.15-5.073a.5.5 0 0 1 .704-.07Z',
    },
    {
      label: 'Carga de Datos',
      link: 'Carga Tipos',
      icon: 'bi-database-fill-up',
      path1:
        'M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m.354-5.854 1.5 1.5a.5.5 0 0 1-.708.708L13 11.707V14.5a.5.5 0 0 1-1 0v-2.793l-.646.647a.5.5 0 0 1-.708-.708l1.5-1.5a.5.5 0 0 1 .708 0M8 1c-1.573 0-3.022.289-4.096.777C2.875 2.245 2 2.993 2 4s.875 1.755 1.904 2.223C4.978 6.711 6.427 7 8 7s3.022-.289 4.096-.777C13.125 5.755 14 5.007 14 4s-.875-1.755-1.904-2.223C11.022 1.289 9.573 1 8 1',
      path2:
        'M2 7v-.839c.457.432 1.004.751 1.49.972C4.722 7.693 6.318 8 8 8s3.278-.307 4.51-.867c.486-.22 1.033-.54 1.49-.972V7c0 .424-.155.802-.411 1.133a4.51 4.51 0 0 0-4.815 1.843A12 12 0 0 1 8 10c-1.573 0-3.022-.289-4.096-.777C2.875 8.755 2 8.007 2 7m6.257 3.998L8 11c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V10c0 1.007.875 1.755 1.904 2.223C4.978 12.711 6.427 13 8 13h.027a4.55 4.55 0 0 1 .23-2.002m-.002 3L8 14c-1.682 0-3.278-.307-4.51-.867-.486-.22-1.033-.54-1.49-.972V13c0 1.007.875 1.755 1.904 2.223C4.978 15.711 6.427 16 8 16c.536 0 1.058-.034 1.555-.097a4.5 4.5 0 0 1-1.3-1.905',
    },
    {
      label: 'Reportes',
      /* link: 'ConsultaReportes', */
      link: 'MenuReportes',
      icon: 'clipboard2-data',
      path1:
        'M9.5 0a.5.5 0 0 1 .5.5.5.5 0 0 0 .5.5.5.5 0 0 1 .5.5V2a.5.5 0 0 1-.5.5h-5A.5.5 0 0 1 5 2v-.5a.5.5 0 0 1 .5-.5.5.5 0 0 0 .5-.5.5.5 0 0 1 .5-.5z',
      path2:
        'M3 2.5a.5.5 0 0 1 .5-.5H4a.5.5 0 0 0 0-1h-.5A1.5 1.5 0 0 0 2 2.5v12A1.5 1.5 0 0 0 3.5 16h9a1.5 1.5 0 0 0 1.5-1.5v-12A1.5 1.5 0 0 0 12.5 1H12a.5.5 0 0 0 0 1h.5a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5z',
      path3: 'M10 7a1 1 0 1 1 2 0v5a1 1 0 1 1-2 0zm-6 4a1 1 0 1 1 2 0v1a1 1 0 1 1-2 0zm4-3a1 1 0 0 0-1 1v3a1 1 0 1 0 2 0V9a1 1 0 0 0-1-1',
    },
    {
      label: 'Informe Mensual',
      link: 'InformeMensual',
      icon: 'bi bi-newspaper',
      path1:
        'M0 2.5A1.5 1.5 0 0 1 1.5 1h11A1.5 1.5 0 0 1 14 2.5v10.528c0 .3-.05.654-.238.972h.738a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 1 1 0v9a1.5 1.5 0 0 1-1.5 1.5H1.497A1.497 1.497 0 0 1 0 13.5zM12 14c.37 0 .654-.211.853-.441.092-.106.147-.279.147-.531V2.5a.5.5 0 0 0-.5-.5h-11a.5.5 0 0 0-.5.5v11c0 .278.223.5.497.5z',
      path2:
        'M2 3h10v2H2zm0 3h4v3H2zm0 4h4v1H2zm0 2h4v1H2zm5-6h2v1H7zm3 0h2v1h-2zM7 8h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2zm-3 2h2v1H7zm3 0h2v1h-2z',
    },
    {
      label: 'Mant Catálogos',
      link: 'MenuCatalogos',
      icon: 'MenuCatalogos',
      path1:
        'M7.5 1a.5.5 0 0 0-1 0v1.586l-.793.793a1 1 0 0 0 0 1.414l1.414 1.414a1 1 0 0 0 1.414 0l.793-.793H11a.5.5 0 0 0 0-1h-2.586l-.793.793a.5.5 0 0 1-.707 0L5.5 3.707a.5.5 0 0 1 0-.707L6.293 2H7.5V1z',
      path2:
        'M3.5 3a.5.5 0 0 0-.5.5V4h-1A1.5 1.5 0 0 0 .5 5.5v8A1.5 1.5 0 0 0 2 15h8a1.5 1.5 0 0 0 1.5-1.5v-1h.5a.5.5 0 0 0 0-1h-.5V8h.5a.5.5 0 0 0 0-1h-.5V5.5A1.5 1.5 0 0 0 10 4h-1v-.5a.5.5 0 0 0-.5-.5h-5zM2 5h8a.5.5 0 0 1 .5.5V7h-9V5.5A.5.5 0 0 1 2 5zm-1 3h10v5.5a.5.5 0 0 1-.5.5h-9a.5.5 0 0 1-.5-.5V8z',
    },
  ];

  public selectItem(item: string): void {
    this.selectedItem = item;
  }

  public logout(): Promise<any> {
    return this.loginService()
      .logout()
      .then(response => {
        this.$store.commit('logout');
        if (this.$route.path !== '/') {
          return this.$router.push('/');
        }
      });
    return Promise.resolve(this.$router.currentRoute);
  }

  public openLogin(): void {
    this.loginService().openLogin((<any>this).$root);
  }

  public get authenticated(): boolean {
    return this.$store.getters.authenticated;
  }

  public myFunction2(descSeccion: string): void {
    console.log(descSeccion + ' entra a function');
    const list = document.getElementById(descSeccion)?.classList;
    console.log(list);
    list?.add('myStyle');
  }
}
